// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BottomDrawer_wrapper__ERA1w"};